"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    pxToRem,
    setEndDirection
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors,
    fontFamily,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccTaskManagerIframeStyle = (0, _react.useMemo)(() => {
    const ccTaskManagerIframe = (0, _css.css)({
      fontFamily: fontFamily,
      direction: direction,
      userSelect: 'none',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: themeColors?.general.light,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'flexStart',
      alignItems: 'stretch',
      zIndex: 9999999999
    });
    const ccTaskManagerIframeTitle = (0, _css.css)({
      padding: `${pxToRem(20)} ${pxToRem(20)} 0 ${pxToRem(20)}`,
      lineHeight: pxToRem(29),
      color: themeColors?.general.text,
      fontWeight: 'bold',
      span: {
        fontSize: pxToRem(24)
      }
    });
    const ccTaskManagerIframeContent = (0, _css.css)({
      position: 'relative',
      flex: 'auto',
      iframe: {
        border: 'none'
      }
    });
    const ccTaskManagerIframeCloseBtn = (0, _css.css)({
      position: 'absolute',
      top: pxToRem(10),
      ...setEndDirection(10),
      zIndex: 1
    });
    return {
      ccTaskManagerIframe,
      ccTaskManagerIframeTitle,
      ccTaskManagerIframeContent,
      ccTaskManagerIframeCloseBtn
    };
  }, [direction, fontFamily, pxToRem, setEndDirection, themeColors?.general.light, themeColors?.general.text]);
  return {
    'cc-TaskManager__iframe': ccTaskManagerIframeStyle.ccTaskManagerIframe,
    'cc-TaskManager__iframe__title': ccTaskManagerIframeStyle.ccTaskManagerIframeTitle,
    'cc-TaskManager__iframe__content': ccTaskManagerIframeStyle.ccTaskManagerIframeContent,
    'cc-TaskManager__iframe__close-btn': ccTaskManagerIframeStyle.ccTaskManagerIframeCloseBtn
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;